import React, { useState } from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import styled from 'styled-components';
import { IAgentPromptLogReference } from 'types/agentPromptLog';
import AgentPromptLogModal from '../../../components/AgentPromptLog/AgentPromptLogModal';
import { AsyncTaskStatus } from 'constants/conceptLinkerValidatorStatus';

interface RunWithLog {
  run_number: number;
  async_task_status: number;
  agent_prompt_log?: IAgentPromptLogReference;
}

const AgentPromptLogRenderer: React.FC<ICellRendererParams> = (params) => {
  const [showModal, setShowModal] = useState(false);

  // Check if this is a grouped item with runs array
  const runs = params.data?.runs as RunWithLog[] | undefined;

  if (runs && runs.length > 0) {
    // Grouped item - collect logs from runs that have DONE status
    const logsFromRuns = runs.filter(
      (run) => run.async_task_status === AsyncTaskStatus.DONE && run.agent_prompt_log
    );

    if (logsFromRuns.length === 0) {
      return null;
    }

    // Collect log references with run information
    const runLogs = logsFromRuns.map((run) => ({
      runNumber: run.run_number,
      logRef: run.agent_prompt_log!,
    }));
    const firstLog = runLogs[0].logRef;

    const handleClick = () => {
      setShowModal(true);
    };

    return (
      <>
        <IconContainer onClick={handleClick} title="View AI Prompt & Response">
          <i className="fa fa-window-maximize" />
        </IconContainer>
        {showModal && (
          <AgentPromptLogModal
            entityType={firstLog.log_entity_type}
            entityId={firstLog.log_entity_id}
            runLogs={runLogs}
            onClose={() => setShowModal(false)}
          />
        )}
      </>
    );
  }

  // Single item (non-grouped) - original behavior
  const asyncTaskStatus = params.data?.async_task_status as AsyncTaskStatus | undefined;

  if (asyncTaskStatus !== AsyncTaskStatus.DONE) {
    return null;
  }

  // Get agent_prompt_log data directly from the cell value
  const agentPromptLog: IAgentPromptLogReference | undefined = params.value;

  // No log data available (item processed before logging was added or not processed yet)
  if (!agentPromptLog) {
    return null;
  }

  // For Translation project translate: hide if similarity is not 0
  const similarity = params.data?.item_info?.similarity;
  if (similarity != null && similarity !== 0) {
    return null;
  }

  const handleClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <IconContainer onClick={handleClick} title="View AI Prompt & Response">
        <i className="fa fa-window-maximize" />
      </IconContainer>
      {showModal && (
        <AgentPromptLogModal
          entityType={agentPromptLog.log_entity_type}
          entityId={agentPromptLog.log_entity_id}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default AgentPromptLogRenderer;

const IconContainer = styled.span`
  cursor: pointer;
  color: #1976d2;
  transition: color 0.2s ease;

  &:hover {
    color: #1565c0;
  }
`;
